/**
 * @generated SignedSource<<c3d2fce4acabf7dac599637a5628d828>>
 * @relayHash bc450265ee46e4c0655689ff58bc799e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4f967c9ef71ccd87132defc190618817e8da5122967a3303cfaaac5bb553b483

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

import isSavedViewsBoardColumnSettingsEnabled_provider from '@atlassian/jira-relay-provider/src/saved-views-board-column-settings.relayprovider';
import withFiltersAndColumnSettings_provider from '@atlassian/jira-relay-provider/src/saved-views-board-filter-and-column-settings.relayprovider';
import withFilters_provider from '@atlassian/jira-relay-provider/src/saved-views-board-filter-setting.relayprovider';
import withSelectedWorkflow_provider from '@atlassian/jira-relay-provider/src/saved-views-board-selected-workflow-setting.relayprovider';
import isSaveResetViewEnabled_provider from '@atlassian/jira-relay-provider/src/sv-230-save-revert-board-view-settings.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4f967c9ef71ccd87132defc190618817e8da5122967a3303cfaaac5bb553b483",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardcolumnsettingsrelayprovider": isSavedViewsBoardColumnSettingsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardfiltersettingrelayprovider": withFilters_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardselectedworkflowsettingrelayprovider": withSelectedWorkflow_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardfilterandcolumnsettingsrelayprovider": withFiltersAndColumnSettings_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsv230saverevertboardviewsettingsrelayprovider": isSaveResetViewEnabled_provider
    }
  }
};

export default node;
